import { Button, Form, FormProps, Input } from 'antd'
import { ReactNode } from 'react'
import { EditFolderDTO } from '../../utils/redux/moodsSlice'
import { UploadedFolderDestination } from '../PlaylistFolder/NewFolder'
import { PlaylistPosterFormItem } from '../PlaylistForm/PlaylistPosterFormItem'

interface Props extends FormProps<EditFolderDTO> {
  isLoading: boolean
  uploadedDestination: UploadedFolderDestination
  playlistTable?: ReactNode
}
export default function PlaylistFolderForm({
  isLoading,
  uploadedDestination,
  playlistTable,
  ...formProps
}: Props) {
  // const {onFinish, initialValues} = formProps
  return (
    <>
      <Form layout="vertical" {...formProps}>
        <Form.Item name="image" rules={[{ required: true }]}>
          <PlaylistPosterFormItem
            uploadedDestination={uploadedDestination}
          />
        </Form.Item>

        <Form.Item
          name="title"
          rules={[{ required: true, message: 'Please input playlist title!' }]}
        >
          <Input placeholder="Title" />
        </Form.Item>
        {playlistTable}
        <Form.Item>
          <Button block type="primary" htmlType="submit" loading={isLoading} style={{marginTop: '1.5em'}}>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  )
}
